// Public welcome page — same dictionary treatment as the splash, but as
// a permanent route with explicit CTAs. Linked from the auth pages'
// brand wordmark, and serves as a marketing/about landing.

import { Link, Navigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { DictionaryEntry } from '../components/DictionaryEntry';
import { Row } from '../components/ui';

export default function WelcomePage() {
  const { user, loading } = useAuth();

  if (loading) return null;
  // Already signed-in users don't need the welcome — send them straight in.
  if (user) return <Navigate to="/" replace />;

  return (
    <div
      style={{
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--space-8) var(--space-6)',
        gap: 'var(--space-12)',
      }}
    >
      <DictionaryEntry size="lg" animatedLogo />
      <Row gap={3} justify="center">
        <Link to="/signin" className="ds-button ds-button--secondary ds-button--lg">
          Sign in
        </Link>
        <Link to="/signup" className="ds-button ds-button--primary ds-button--lg">
          Create account
          <ArrowRight size={16} strokeWidth={2} />
        </Link>
      </Row>
    </div>
  );
}
